export default {
  name: 'MonitoringLegacyRouter',
  render () { return <router-view/> }
}
